/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Placeholder_UrlInputs */

const en_link_editor_placeholder_url = /** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://`)
};

const es_link_editor_placeholder_url = /** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://`)
};

const fr_link_editor_placeholder_url = /** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://`)
};

const de_link_editor_placeholder_url = /** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://`)
};

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const ja_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const zh_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const ar_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const id_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const it_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const ru_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const pt_link_editor_placeholder_url = en_link_editor_placeholder_url;

/** @type {(inputs: Link_Editor_Placeholder_UrlInputs) => LocalizedString} */
const ko_link_editor_placeholder_url = en_link_editor_placeholder_url;

/**
* | output |
* | --- |
* | "https://" |
*
* @param {Link_Editor_Placeholder_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_placeholder_url = /** @type {((inputs?: Link_Editor_Placeholder_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Placeholder_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_placeholder_url(inputs)
	if (locale === "es") return es_link_editor_placeholder_url(inputs)
	if (locale === "fr") return fr_link_editor_placeholder_url(inputs)
	if (locale === "de") return de_link_editor_placeholder_url(inputs)
	if (locale === "ja") return ja_link_editor_placeholder_url(inputs)
	if (locale === "zh") return zh_link_editor_placeholder_url(inputs)
	if (locale === "ar") return ar_link_editor_placeholder_url(inputs)
	if (locale === "id") return id_link_editor_placeholder_url(inputs)
	if (locale === "it") return it_link_editor_placeholder_url(inputs)
	if (locale === "ru") return ru_link_editor_placeholder_url(inputs)
	if (locale === "pt") return pt_link_editor_placeholder_url(inputs)
	return ko_link_editor_placeholder_url(inputs)
});